import { ICustomer, ICustomerListItem } from 'interfaces/customer-interfaces';
import _ from 'lodash';
import React from 'react';
import CreateNewActivityRecordModalV2Inner from './CreateNewActivityRecordModalV2Inner';
import { Drawer } from '@good/ui/core';

interface ICreateNewActivityRecordModalV2Props {
  isOpen: boolean;
  selectedCustomer?: ICustomerListItem | ICustomer;
  onClose: () => void;
}

export const CreateNewActivityRecordModalV2 = ({
  isOpen,
  onClose,
  selectedCustomer,
}: ICreateNewActivityRecordModalV2Props) => {
  return (
    <Drawer.Root opened={isOpen} onClose={() => {}} size='xl'>
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Body p={0}>
          <CreateNewActivityRecordModalV2Inner selectedCustomer={selectedCustomer} onClose={onClose} />
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};
